import { render, staticRenderFns } from "./ot-autocomplete-wrapper.vue?vue&type=template&id=17bf09d3&scoped=true&"
import script from "./ot-autocomplete-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-autocomplete-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-autocomplete-wrapper.vue?vue&type=style&index=0&id=17bf09d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf09d3",
  null
  
)

export default component.exports